import { message } from "antd";
import axiosInstance from "../shared/axios";

const getAllStats = async () => {
  try {
    let result = await axiosInstance.get("/dashboard/stats");
    if (result?.status === 200 && result?.data?.success) {
      return result?.data; // ✅ not result?.data?.data
    } else {
      message.error("Error while loading dashboard stats");
      return null;
    }
  } catch (error) {
    message.error("Error while loading dashboard stats");
    return null;
  }
};

const getSessionAndClientsOverview = async (params) => {
  try {
    const result = await axiosInstance.get(
      "/dashboard/getSessionsAndClientsOverview",
      {
        params: {
          filter: params?.filter || "",
        },
      },
    );
    if (result?.status === 200 && result?.data?.success) {
      return {
        data: result?.data || [],
      };
    } else {
      message.error(
        "Error while loading dashboard sessions and clients overview",
      );
      return { data: [], total: 0 };
    }
  } catch (error) {
    message.error(
      error?.response?.data?.message ||
        "Error while loading dashboard sessions and clients overview",
    );
    return { data: [], total: 0 };
  }
};

const getTodaySessions = async (params) => {
  try {
    const result = await axiosInstance.get("/dashboard/todaySessions", {
      params: {
        pageNo: params?.pageNo,
        recordsPerPage: params?.recordsPerPage,
      },
    });
    if (result?.status === 200 && result?.data?.success) {
      return {
        data: result?.data?.data || [],
        total: result?.data?.totalRecords || 0,
      };
    } else {
      message.error("Error while loading today's sessions");
      return { data: [], total: 0 };
    }
  } catch (error) {
    message.error(
      error?.response?.data?.message || "Error while loading today's sessions",
    );
    return { data: [], total: 0 };
  }
};

const getTomorrowSessions = async (params) => {
  try {
    const result = await axiosInstance.get("/dashboard/tomorrowSessions", {
      params: {
        pageNo: params?.pageNo,
        recordsPerPage: params?.recordsPerPage,
      },
    });
    if (result?.status === 200 && result?.data?.success) {
      return {
        data: result?.data?.data || [],
        total: result?.data?.totalRecords || 0,
      };
    } else {
      message.error("Error while loading tomorrow's sessions");
      return { data: [], total: 0 };
    }
  } catch (error) {
    message.error(
      error?.response?.data?.message ||
        "Error while loading tomorrow's sessions",
    );
    return { data: [], total: 0 };
  }
};

const getViewSessionsAll = async (params) => {
  try {
    const result = await axiosInstance.get("/sessions/viewAll", {
      params: {
        pagination: false,
      },
    });

    if (result?.status === 200 && result?.data?.success) {
      return {
        data: result?.data || [],
        total: result?.data?.totalRecords || 0,
      };
    } else {
      message.error("Error while loading sessions");
      return { data: [], total: 0 };
    }
  } catch (error) {
    message.error(
      error?.response?.data?.message || "Error while loading sessions",
    );
    return { data: [], total: 0 };
  }
};

const getTodaysDraft = async (params) => {
  try {
    const result = await axiosInstance.get("/dashboard/todayDrafts", {
      params: {
        pageNo: params?.pageNo,
        recordsPerPage: params?.recordsPerPage,
      },
    });
    if (result?.status === 200 && result?.data?.success) {
      return {
        data: result?.data?.data || [],
        total: result?.data?.totalRecords || 0,
      };
    } else {
      message.error("Error while loading today's drafts ");
      return { data: [], total: 0 };
    }
  } catch (error) {
    message.error(
      error?.response?.data?.message || "Error while loading today's drafts ",
    );
    return { data: [], total: 0 };
  }
};

const getAppointmentEditById = async (id) => {
  try {
    let result = await axiosInstance.get(`/appointment/edit/${id}`);
    if (result?.status === 200 && result?.data?.success) {
      return result?.data?.data;
    } else {
      message.error("Error while loading appointment detail");
      return 1;
    }
  } catch (error) {
    console.error("Error fetching appointment detail:", error);
    message.error("Error while loading appointment detail");
    return null;
  }
};

export const dashboardapi = {
  getAllStats,
  getSessionAndClientsOverview,
  getTodaySessions,
  getTomorrowSessions,
  getViewSessionsAll,
  getTodaysDraft,
  getAppointmentEditById,
};
